/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.SearchUtils = {
  adjustViewMode() {
    hitsContainer = $('ol.ais-InfiniteHits-list')

    if (GridListToggler.getViewMode() == 'grid') {
      hitsContainer.addClass('vertical')
    }
    else {
      hitsContainer.removeClass('vertical')
    }
  },

  setUpCustomListsLink(selector) {
    return $(selector).on('click', function (e) {
      e.preventDefault();
      const url = new URL(window.location);
      url.searchParams.delete('list');
      return window.history.pushState({}, '', url.pathname + url.search);
    });
  },

  exportCompanies(e, searchObjekt, url) {
    e.preventDefault();
    const params = eval(searchObjekt)._searchObject.helper.getState();
    const url_params = $.param({
      query: params.query,
      filters: params.filters,
      disjunctiveFacetsRefinements: params.disjunctiveFacetsRefinements,
      numericRefinements: params.numericRefinements,
      description: $("#description").is(":checked")
    });
    return window.location = [url, url_params].join('?');
  },

  // Factory for creating a configured InstantSearch instance.
  // Centralises IS v4 setup so future global config (analytics, locale) is
  // applied in one place. Returns the instance — caller controls lifecycle.
  // `options` is merged in last and can override routing or any other setting.
  createInstantSearch(appId, key, indexName, options = {}) {
    return instantsearch({
      searchClient: algoliasearch(appId, key),
      indexName,
      routing: true,
      ...options
    });
  }
};
